import { TimelyHero } from "@/sections/TimelyHero";
import { TimelyFeatures } from "@/sections/TimelyFeatures";
import { TimelyHowItWorks } from "@/sections/TimelyHowItWorks";
import { TimelyTestimonials } from "@/sections/TimelyTestimonials";
import { TimelyCTA } from "@/sections/TimelyCTA";

export default function HomePage() {
  return (
    <>
      <TimelyHero />
      <TimelyFeatures />
      <TimelyHowItWorks />
      <TimelyTestimonials />
      <TimelyCTA />
    </>
  );
} 